import React, { useMemo } from 'react';
import { ButtonProps } from 'antd/lib/button';
import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import CcNode from '../../../services/models/CcNode';
import JobCreateActionButton from '../../Jobs/JobCreateActionButton';

export default NodeStopSlaveButton;

export type NodeStopSlaveButtonProps = ButtonProps & {
    node: CcNode;
    title?: string;
    children?: React.ReactNode;
    onSuccess?: () => void;
};

function NodeStopSlaveButton({
    node,
    title,
    children,
    onSuccess,
    ...rest
}: NodeStopSlaveButtonProps) {
    const jobData = useMemo(
        () => ({
            node: { hostname: node.hostname, port: node.port },
        }),
        []
    );

    return (
        <JobCreateActionButton
            clusterId={node.clusterid}
            command={CmonJobInstanceCommand.STOP_REPLICATION_SLAVE}
            confirmTitle={`${title || 'Stop replica'}: ${node.getName()}?`}
            title={title || 'Stop replica'}
            jobData={jobData}
            onSuccess={onSuccess}
            extraKey={[node.hostname, node.port]}
            {...rest}
        />
    );
}
